import { Component, AfterViewInit, ViewContainerRef, NgZone, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { Habito } from '../../../models/';
import { HabitosService, LoginService, } from '../../../services/';
import { HabitosDetalleComponent } from './detallehabitos/detallehabitos.component';

@Component({
  selector: 'qs-habitos',
  templateUrl: './habitos.component.html',
  styleUrls: ['./habitos.component.scss'],
  viewProviders: [HabitosService],
})

export class HabitosComponent implements AfterViewInit {

  private idPaciente: string;
  private habitos: any;

  private isSmallScreen: boolean = false;
  private _querySubscription: Subscription;

  private columnsAll: ITdDataTableColumn[] = [
    { name: 'fecha', label: 'Fecha inicio', tooltip: 'Fecha inicio', sortable: true },
    { name: 'nombre', label: 'Nombre', sortable: true },
    { name: 'tipo', label: 'Tipo', tooltip: 'Tipo', sortable: false },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _habitosService: HabitosService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Hábitos');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('habitos.load');
    this._habitosService.obtenerHabitosPaciente(this.idPaciente).subscribe((res: any) => {
      this.habitos = res.respuesta.habitos || [];
      this.filteredData = this.habitos;
      this.filteredDataTotal = this.habitos.length;
      this._loadingService.resolve('habitos.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo hábitos.', 'OK', 6000);
      this._loadingService.resolve('habitos.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  /**
   * Abre una vista detalle de la consulta
   * @param habito
   */
  openDetail(habito: any): void {
    let dialogRef: any = this._dialogService.open(HabitosDetalleComponent, {
      data: habito,
      width: '75%',
      role: 'dialog',
    });
    dialogRef.componentInstance.habito = habito;
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.habitos;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/habitos/habitos.component.ts